import { render } from "./_loader.vue?vue&type=template&id=2e60a82d&lang=pug"
import script from "./_loader.vue?vue&type=script&lang=js"
export * from "./_loader.vue?vue&type=script&lang=js"

import exportComponent from "/appwd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__